import type { CotizacionWorldOffice } from '@/lib/supabase/tipos-bd'
import { Cargando } from '@/shared/ui/Estados/Cargando'

import { HojaCotizacion } from './HojaCotizacion'
import { useHojaCotizacion } from './useHojaCotizacion'

/**
 * El documento de una cotización de la lista de World Office.
 *
 * Solo junta la fila que ya está en pantalla con sus renglones, que es lo
 * único que hay que ir a buscar. La hoja en sí no sabe de dónde viene nada:
 * recibe datos y dibuja papel.
 */
export function HojaDeLaCotizacion({
  cotizacion,
  onCerrar,
}: {
  cotizacion: CotizacionWorldOffice
  onCerrar: () => void
}) {
  const { data, isLoading } = useHojaCotizacion({
    idAsiento: cotizacion.id_asiento,
    cotizacionId: cotizacion.cotizacion_id,
    numero: cotizacion.numero_visible,
    prefijo: cotizacion.prefijo,
    fecha: cotizacion.fecha,
    cliente: cotizacion.cliente_en_la_matriz ?? cotizacion.cliente_nombre,
    clienteDocumento: cotizacion.cliente_identificacion,
    // El vendedor, no el usuario de la sesión de World Office (0161).
    vendedor: cotizacion.vendedor_nombre ?? cotizacion.elaborada_por_world_office,
    concepto: cotizacion.orden_numero ? 'Orden de servicio ' + cotizacion.orden_numero : null,
  })

  if (isLoading || !data) return <Cargando mensaje="GENERANDO DOCUMENTO COTIZACIÓN..." />

  return <HojaCotizacion datos={data} onCerrar={onCerrar} />
}
